import * as React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import Spinner from './Spinner';

export const SpinnerLoader: React.FunctionComponent = () => {
    const { promiseInProgress } = usePromiseTracker();

    if (!promiseInProgress) return null;

    return (
        <div id="spinner">
            <Spinner />
        </div>
    );
};
